<template>
<div id="ccAlert">

  <!-- Modal -->
  <div class="modal fade" id="myModal" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
           <div v-html="msg"></div>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>

  export default {

    data(){
      return{
        msg: null,
      }
    },

    methods: {
      receber_dados(m){
        this.msg = m
        var myModal = new bootstrap.Modal(document.getElementById('myModal'))
        myModal.show()
      },
    },

  }

</script>


<style scoped>

    .modal-content{
      background-color: orange;
      color: #000;
    }

    .texto{
      padding: 10px, 0, 10px, 0;
      font-size: 17px;
    }

</style>


// WEBPACK FOOTER //
// src/components/cc_geral/cc_alert.vue